import { UploadedMarkup } from '@retail/markup/types';
import {
  toConditionBinding,
  CreateCalculusConditions,
  ConditionBinding,
  ConditionsNew,
} from '@retail/calculus/types';
import { getISO_8601Date } from '@retail/utils';

export const getImportedMarkupConditions = (
  validMarkups: UploadedMarkup[],
  currentConditions?: ConditionsNew[]
): CreateCalculusConditions[] => {
  return validMarkups.map(
    ({
      mgSupplierId,
      mgItemNumber,
      productGroupNumber,
      discountGroupCode,
      validFrom,
      salesFactor,
      coverageDegree,
      salesPrice,
      gtinCode,
      incMva,
    }) => {
      const bindingLevel = toConditionBinding({
        supplierNumber: mgSupplierId,
        mgItemNumber,
        groupNumber: productGroupNumber,
        groupCode: discountGroupCode,
        gtinCode,
      });

      if (currentConditions) {
        const currentContent = getCurrentContent(currentConditions, bindingLevel);
        const currentPriceSuggestions =
          currentContent?.priceSourceCondition?.priorities.map(
            (prio) => prio.priceSuggestionType
          ) ?? [];

        return {
          content: {
            markup: salesFactor ? { salesFactor } : undefined,
            markupCoverageDegree: coverageDegree ? { coverageDegree } : undefined,
            markupTargetPrice:
              salesPrice && incMva ? { targetPrice: salesPrice, incMva } : undefined,
            priceSuggestion: {
              priorities: [...currentPriceSuggestions, 'MARKUP'],
            },
          },
          binding: bindingLevel,
          validFrom: getISO_8601Date(validFrom),
        };
      }
      return {
        content: {
          markup: salesFactor ? { salesFactor } : undefined,
          markupCoverageDegree: coverageDegree ? { coverageDegree } : undefined,
          markupTargetPrice: salesPrice && incMva ? { targetPrice: salesPrice, incMva } : undefined,
        },
        binding: bindingLevel,
        validFrom: getISO_8601Date(validFrom),
      };
    }
  );
};

const getCurrentContent = (currentCondition: ConditionsNew[], bindingLevel: ConditionBinding) =>
  currentCondition.find((cond) => bindingsMatch(cond.getBindingLevel(), bindingLevel));

const bindingsMatch = (a: ConditionBinding, b: ConditionBinding): boolean => {
  if (b.legacySupplierItem) {
    return a.legacySupplierItem?.mgItemNumber === b.legacySupplierItem.mgItemNumber;
  } else if (b.discountGroup) {
    return a.discountGroup?.groupCode === b.discountGroup.groupCode;
  } else if (b.productGroup) {
    return a.productGroup?.groupNumber === b.productGroup.groupNumber;
  } else if (b.supplier) {
    return a.supplier?.supplierNumber === b.supplier.supplierNumber;
  } else {
    return false;
  }
};
